import { JSX } from 'react';

import SubscriptionAmediatekaSVG from '@/icons/SubscriptionAmediatekaSVG';
import SubscriptionOnlineTvSVG from '@/icons/SubscriptionOnlineTvSVG';
import SubscriptionPremiumSVG from '@/icons/SubscriptionPremiumSVG';
import SubscriptionSetantaSVG from '@/icons/SubscriptionSetantaSVG';
import SubscriptionStandartSVG from '@/icons/SubscriptionStandartSVG';
import SubscriptionStartSVG from '@/icons/SubscriptionStartSVG';
import SubscriptionUzVideoSVG from '@/icons/SubscriptionUzVideoSVG';
import SubscriptionWinkSVG from '@/icons/SubscriptionWinkSVG';
import { SVGProps } from '@/types/common.types';

// =================================================================

export type SubscriptionLogoProps = {
  bgImage: string;
  logoSvg: (props: SVGProps) => JSX.Element;
};

export const imagesSubscriptions: Record<number, SubscriptionLogoProps> = {
  27: {
    bgImage: '/assets/images/subscription-bg-1.png',
    logoSvg: SubscriptionPremiumSVG,
  },
  24: {
    bgImage: '/assets/images/subscription-bg-2.png',
    logoSvg: SubscriptionStandartSVG,
  },
  16: {
    bgImage: '/assets/images/subscription-bg-3.png',
    logoSvg: SubscriptionAmediatekaSVG,
  },
  22: {
    bgImage: '/assets/images/subscription-bg-4.png',
    logoSvg: SubscriptionWinkSVG,
  },
  26: {
    bgImage: '/assets/images/subscription-bg-5.png',
    logoSvg: SubscriptionStartSVG,
  },
  21: {
    bgImage: '/assets/images/subscription-bg-6.png',
    logoSvg: SubscriptionUzVideoSVG,
  },
  25: {
    bgImage: '/assets/images/subscription-bg-7.png',
    logoSvg: SubscriptionOnlineTvSVG,
  },
  23: {
    bgImage: '/assets/images/subscription-bg-8.png',
    logoSvg: SubscriptionSetantaSVG,
  },
};
